import { Grid, TextField, Typography } from '@mui/material';
import { ICashAsset } from '../../../../../../Interfaces/Asset/ICashAsset';
import { ITestamentAssetsViewProps } from '../../../../../../Interfaces/Asset/ITestamentAssetsViewProps';

type CashAssetViewProps = ITestamentAssetsViewProps<ICashAsset>;

export function CashAssetView({ asset, setAsset }: CashAssetViewProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant='body2'>
          Geben Sie hier bitte nur Barbeträge in Euro an. Für Barbeträge in
          anderen Währungen nutzen Sie bitte die "Auslandsvermögen".
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Betrag in Euro'
          size='small'
          value={asset.data.amount || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                amount: Number(event.target.value),
              },
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Sonstige Informationen'
          rows={2}
          size='small'
          multiline
          value={asset.data.notes || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                notes: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
